import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { FieldValues, SubmitHandler, useForm } from "react-hook-form";

import BusImage from "../../assets/images/bus.png";
import Bus from "../../assets/images/buss.png";

import Transport from "../../assets/icons/transport.svg";
import Hospitality from "../../assets/icons/hospitality.svg";
import Haulage from "../../assets/icons/haulage.svg";
import Courier from "../../assets/icons/courier.svg";

// import Building from "../../assets/images/buildings.png";
import FormInput from "../../components/form/formInput/FormInput";
import FormButton from "../../components/form/formButton/FormButton";
import { setBooking } from "../../reducer/bookingSlice";
import FormSelect from "../../components/form/formSelect/FormSelect";

const Home = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [type, setType] = useState<"book" | "status">("book");
  const [country, setCountry] = useState<"same" | "different">("same");
  const [bookingType, setBookingType] = useState<"single" | "return">("single");

  const { register, formState, handleSubmit, control } = useForm();
  const onBookRide: SubmitHandler<FieldValues> = (formData) => {
    console.log(formData);
    dispatch(
      setBooking({
        from: formData.from.value,
        to: formData.to.value,
        departureDate: formData.data,
        returnDate: formData.date,
        adult: formData.adults,
        children: formData.children,
      })
    );
    navigate("booking");
  };
  const onCheckStatus: SubmitHandler<FieldValues> = (formData) => {
    console.log(formData);
  };
  return (
    <div className="bg-white  ">
      <div className="container mx-auto pt-24 md:pt-36 pb-20 px-4">
        <div className="relative hero">
          <div className="flex flex-col text-black md:w-[55%] lg:w-[45%] gap-4">
            <div className="head text-5xl font-bold  md:leading-[70px]">
              The modern way to commute{" "}
              <span className="text-[#E8353F]">across cities</span>
            </div>
            <div className="font-medium text-lg md:leading-[30px]">
              Cross Country is an African technology powered company, providing
              seamless mobility services to commuters across Africa
            </div>
          </div>
          {/* BOOK */}
          <div className="md:absolute md:top-0 md:right-0 flex flex-col mt-5 md:mt-0 gap-4 bg-[#F9F9F9] md:w-[45%] lg:w-[50%] xl:w-[45%]">
            <div className="grid grid-cols-2 items-center bg-[#FFF5F6]">
              <div
                className={`head font-bold text-sm cursor-pointer text-center py-3 ${
                  type === "book"
                    ? "text-pry border-b-pry border-b-2"
                    : "text-[#757575]"
                } `}
                onClick={() => setType("book")}
              >
                Book A Trip
              </div>
              <div
                className={`head font-bold text-sm cursor-pointer text-center py-3 ${
                  type === "status"
                    ? "text-pry border-b-pry border-b-2"
                    : "text-[#757575]"
                } `}
                onClick={() => setType("status")}
              >
                Boking Status
              </div>
            </div>
            {type === "status" && (
              <div className="p-4 md:px-8">
                <div className="font font-semibold text-lg mb-2">
                  Confirm your booking status
                </div>
                <form onSubmit={handleSubmit(onCheckStatus)}>
                  <FormInput
                    color="blue"
                    formState={formState}
                    name="reference"
                    register={register}
                    rules={{ required: "Enter reference code" }}
                    type="text"
                    label="Reference Code"
                    placeholder="Enter reference code"
                  />
                  <div className="h-8"></div>
                  <FormButton
                    error={false}
                    label="Confirm Status"
                    loading={false}
                    small
                  />
                </form>
              </div>
            )}
            {type === "book" && (
              <div className="p-4 md:px-8">
                <div className="grid grid-cols-2 items-center bg-white p-2 mb-5">
                  <div
                    className={`head font-bold text-xs whitespace-nowrap cursor-pointer text-center py-3 ${
                      country === "same"
                        ? "text-white bg-[#620005]"
                        : "text-[#757575] bg-[#F9F9F9]"
                    } `}
                    onClick={() => setCountry("same")}
                  >
                    Inter-State
                  </div>
                  <div
                    className={`head font-bold text-xs whitespace-nowrap cursor-pointer text-center py-3 ${
                      country === "different"
                        ? "text-white bg-[#620005]"
                        : "text-[#757575] bg-[#F9F9F9]"
                    } `}
                    onClick={() => setCountry("different")}
                  >
                    West Coast
                  </div>
                </div>
                <div className="flex items-center font-semibold text-sm mb-4 gap-5">
                  <div
                    className={`flex gap-2 items-center p-2 px-4 cursor-pointer ${
                      bookingType === "single"
                        ? "bg-[#B9000A] text-white"
                        : "bg-white text-[#B9000A]"
                    }`}
                    onClick={() => setBookingType("single")}
                  >
                    Single
                  </div>
                  <div
                    className={`flex gap-2 items-center p-2 px-4 cursor-pointer ${
                      bookingType === "return"
                        ? "bg-[#B9000A] text-white"
                        : "bg-white text-[#B9000A]"
                    }`}
                    onClick={() => setBookingType("return")}
                  >
                    Return
                  </div>
                </div>
                {bookingType === "single" && (
                  <form onSubmit={handleSubmit(onBookRide)}>
                    <FormSelect
                      color="blue"
                      control={control}
                      formState={formState}
                      label="Traveling From"
                      name="from"
                      options={[
                        { label: "Lagos", value: "Lagos" },
                        { label: "Kano", value: "Kano" },
                      ]}
                      rules={{ required: "select one" }}
                      placeholder="Enter departure loacation"
                    />

                    <FormSelect
                      color="blue"
                      control={control}
                      formState={formState}
                      label="Traveling To"
                      name="to"
                      options={[
                        { label: "Abuja", value: "Abuja" },
                        { label: "Kogi", value: "Kogi" },
                      ]}
                      rules={{ required: "select one" }}
                      placeholder="Enter destination loacation"
                    />
                    <FormInput
                      formState={formState}
                      name="date"
                      placeholder="Enter date"
                      label="Destination Date"
                      register={register}
                      rules={{ required: "Select date" }}
                      type="date"
                      color="white"
                    />
                    <div className="grid grid-cols-2 gap-3">
                      <FormInput
                        formState={formState}
                        name="adults"
                        placeholder="1"
                        defaultValue="1"
                        label="Adults"
                        register={register}
                        rules={{}}
                        type="number"
                        color="white"
                      />
                      <FormInput
                        formState={formState}
                        name="children"
                        placeholder="1"
                        label="Children"
                        defaultValue="0"
                        register={register}
                        rules={{}}
                        type="number"
                        color="white"
                      />
                    </div>

                    <FormButton
                      small
                      error={false}
                      label="Find My Journey"
                      loading={false}
                    />
                  </form>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="hidden md:flex bg-busImage bg-cover items-start justify-center  w-full mx-auto ">
        <img src={BusImage} alt="" className="w-full" />
      </div>
      <div className="bg-white md:mt-16  ">
        <div className="container flex justify-center items-center mx-auto bg-logoImage text-black bg-contain bg-no-repeat bg-center  py-10 px-4">
          <div className="flex flex-col justify-center items-center md:w-[60%] gap-4">
            <div className="flex items-center gap-3 head font-bold text-2xl">
              <div className="bg-black w-4 h-2"></div>
              <div>
                About <span className="text-pry">Cross Country</span>
              </div>
              <div className="bg-black w-4 h-2"></div>
            </div>
            <div className="text-lg font-medium text-center">
              Cross Country Limited is incorporated on May 2, 2001, with RC:
              409063 to carry on the business of proprietors and carriers of
              goods and passengers both in public conveyances and in private
              vehicles. The company commenced operations of intercity and
              intracity transportations in December 2002 with fleet of 132
              vehicles.
            </div>
            <button className="outline:none p-3 px-5 bg-[#B9000A] mt-5 text-white ">
              Learn More
            </button>
          </div>
        </div>
      </div>
      {/*  */}
      <div className="relative h-[300px] lg:h-[400px] py-4 mb-20">
        {/* <img src={Building} alt="" className="background" /> */}
        <div className="background ">
          <img
            src={Bus}
            className="absolute bottom-4 left-[40%] w-[100px] md:w-[200px] lg:w-[300px]"
            alt=""
          />
        </div>
      </div>
      {/*  */}
      <div className="bg-white">
        <div className="container mx-auto  flex justify-center items-center">
          <div className="flex flex-col justify-center items-center md:w-[60%] gap-4">
            <div className="flex items-center gap-3 head font-bold text-2xl">
              <div className="bg-black w-4 h-2"></div>
              <div>
                What <span className="text-pry">We Provide</span>
              </div>
              <div className="bg-black w-4 h-2"></div>
            </div>
            <div className="text-lg font-medium text-center">
              Below is a list of some of the services we provide.
            </div>
          </div>
        </div>
      </div>
      {/*  */}
      <div className="bg-dot mt-10 md:mt-36">
        <div className="md:h-[350px] relative container mx-auto flex items-center justify-center">
          <div className="md:absolute md:-top-24 grid grid-cols-1 md:grid-cols-4 gap-4 px-10">
            <div className="flex flex-col items-center justify-start bg-white border border-[#620005] px-5 h-[350px] gap-3">
              <div className="h-20 border border-[#620005]"></div>
              <img src={Transport} alt="" />
              <div className="text-xl font-bold">Transportation</div>
              <div className="text-sm font-medium text-center">
                We provide transportation services for inter city travelers...
              </div>
            </div>
            <div className="flex flex-col items-center justify-start bg-white border border-[#620005] px-5 h-[300px] gap-3">
              <div className="h-20 border border-[#620005]"></div>
              <img src={Hospitality} alt="" />
              <div className="text-xl font-bold">Hospitality</div>
              <div className="text-sm font-medium text-center">
                We provide Hotel / Hospitality services mainly for travellers...
              </div>
            </div>{" "}
            <div className="flex flex-col items-center justify-start bg-white border border-[#620005] px-5 h-[350px] gap-3">
              <div className="h-20 border border-[#620005]"></div>
              <img src={Haulage} alt="" />
              <div className="text-xl font-bold">Haulage</div>
              <div className="text-sm font-medium text-center">
                We provide haulage services for businesses and individual...
              </div>
            </div>{" "}
            <div className="flex flex-col items-center justify-start bg-white border border-[#620005] px-5 h-[300px] gap-3">
              <div className="h-20 border border-[#620005]"></div>
              <img src={Courier} alt="" />
              <div className="text-xl font-bold">Courier Services</div>
              <div className="text-sm font-medium text-center">
                We provide Courier Services for businesses and individual...
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
